import React, { useState, useEffect, useRef, useContext } from "react";
import CustomSlider from "./common/CustomSlider";
import TooltipSlider, { handleRender } from "./common/TooltipSlider";
import "rc-slider/assets/index.css";
import _ from "lodash";
import {
	BgColorToTextColorMapFunc,
	CodesToColorMapFunc,
} from "../CodesToColorMap";
import { DiseaseGroupContext } from "../contexts/diseaseGroupContext";

export const QuestionnaireScalePage = ({
	def,
	onRespond,
	currentResponse,
	code,
}) => {
	const [sliderValue, setSliderValue] = useState(null);

	useEffect(() => {
		if (currentResponse && currentResponse.value) {
			setSliderValue(currentResponse.value);
		} else if (def.answer) {
			setSliderValue(def.answer);

			const response = {
				id: def.id,
				value: def.answer,
			};

			onRespond(response);
		}
	}, [currentResponse, def, onRespond]);

	const { theme } = useContext(DiseaseGroupContext);

	const [marks, setMarks] = useState({});

	useEffect(() => {
		const markRange = _.range(
			def.bounds.min,
			def.bounds.max + 1,
			def.bounds.max / 4
		);

		const tempMarks = {};

		for (const m of markRange) {
			tempMarks[m.toString()] = {
				style: {
					color: BgColorToTextColorMapFunc(CodesToColorMapFunc(code, theme)),
					marginLeft: 15,
				},
				label: m.toString(),
			};
		}

		setMarks(tempMarks);
	}, []);

	const handleChange = (value) => {
		setSliderValue(value);

		const response = currentResponse ?? {
			id: def.id,
			value: value,
		};

		response.value = value;

		onRespond(response);
	};

	return (
		<div className={"mx-3 xs:mx-6"}>
			{def.title ? (
				<h2 className={"text-lg font-bold py-2"}>{def.title}</h2>
			) : null}

			<div className={"flex"}>
				<div className={"flex-1 my-auto mx-3 pb-6"}>
					<p className={"text-sm lg:text-base mb-6"}>{def.instructions}</p>
					<div
						className={"bg-black text-white text-center p-3 mx-auto rounded"}
					>
						<span>{def.bounds.valueLabel.toUpperCase()} =</span>
						<p className="text-white text-xl font-bold">
							{sliderValue ?? "Tap on the scale"}
						</p>
					</div>
				</div>

				<div className={"flex-1 text-center"}>
					<p className="text-sm text-center pb-6">{def.bounds.maxLabel}</p>
					<div
						className={
							"flex items-center justify-center h-slider-xxs xs:h-slider-xs"
						}
					>
						<TooltipSlider
							min={def.bounds.min}
							max={def.bounds.max}
							vertical={true}
							value={sliderValue}
							onChange={handleChange}
							trackStyle={{
								backgroundColor: "#F2413C",
								borderColor: "#F2413C",
								width: 10,
							}}
							handleStyle={{
								borderColor: "#F2413C",
								height: 40,
								width: 40,
								marginLeft: -15,
								opacity: 1,
								backgroundColor: "#F2413C",
							}}
							railStyle={{
								backgroundColor: "darkgrey",
								width: 6,
								margin: 2,
							}}
							marks={marks}
							dotStyle={{
								backgroundColor: "grey",
								width: 10,
								height: 10,
								borderColor: "grey",
							}}
						/>
					</div>

					<p className="text-sm text-center pt-5">{def.bounds.minLabel}</p>
				</div>
			</div>
		</div>
	);
};
